import { createContext, use } from 'react';

import type { BenchmarkingUrlFilters } from './schemas/benchmarkingFilters';

type SetFiltersFn = (
  updater: BenchmarkingUrlFilters | ((prev: BenchmarkingUrlFilters) => BenchmarkingUrlFilters)
) => void;

export type BenchmarkingContextValue = {
  filters: BenchmarkingUrlFilters;
  setFilters: SetFiltersFn;
};

export const BenchmarkingContext = createContext<BenchmarkingContextValue | null>(null);

export function useBenchmarkingContext(): BenchmarkingContextValue {
  const context = use(BenchmarkingContext);
  if (!context) throw new Error('useBenchmarkingContext must be used within BenchmarkingProvider');
  return context;
}
